<template>
  <van-row :class="[...rowClass]">
    <van-col :span="labelSpan"
      ><span :class="['rowLabel', ...labelClass]">{{ data.label }}</span></van-col
    >
    <van-col :span="valueSpan"
      ><span :class="[...valueClass]">{{ data.value }}</span></van-col
    >
  </van-row>
</template>
<script>
import { reactive, toRefs, computed } from 'vue'
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    rowClass: {
      type: Array,
      default: () => []
    },
    labelClass: {
      type: Array,
      default: () => []
    },
    valueClass: {
      type: Array,
      default: () => []
    }
  },
  emits: ['click', 'clickBtn'],
  setup(props, { emit }) {
    let { data, rowClass, labelClass, valueClass } = toRefs(props)
    const state = reactive({
      data,
      rowClass,
      labelClass,
      valueClass
    })
    const labelSpan = computed(() => data.value?.span || 6)
    const valueSpan = computed(() => 24 - labelSpan.value)
    return {
      ...toRefs(state),
      labelSpan,
      valueSpan
    }
  }
}
</script>
<style lang="scss" scoped>
.rowLabel {
  color: #333;
}
</style>
